import React from 'react'

const DeveloperCode = () => {
  return (
    //please dont remove this lg:ml-[264px] mt-[100px] lg:mt-[112px] just write your own code in it. thank you
    <div className='lg:ml-[264px]  mt-[100px] lg:mt-[112px]'>
      {/* write here */}
      Developer Code 
    </div>
  )
}

export default DeveloperCode